module.exports = __webpack_public_path__ + "static/coupon-8e51478c2bd89cc28a6b0c5682c35fa5.jpg";